<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<dialog-titlebar [title]="itemType.pluralDisplay"></dialog-titlebar>

<div mat-dialog-content>
	<app-item-list [itemType]="itemType" [itemList]="getItemListObservable() | async" [editor]="self">
		<!-- itemCreator:  injecting add item panel -->
		<add-edit-member
			itemCreator
			*ngIf="inAddItem"
			(memberCommitEvent)="inAddItem = !completeAdd($event)"
			[rolesApi]="rolesApi"
			[palette]="getItemPaletteColors() | async"
			isOwner="false"
			[editorMode]="editorMode"
			[usedColors]="getUsedColors() | async"
			[itemList$]="itemList$"
			[isAdd]="true"
		>
		</add-edit-member>

		<!-- itemEditor:  injecting edit item panel -->
		<add-edit-member
			itemEditor
			*ngIf="itemInEdit"
			[itemInEdit]="itemInEdit"
			[item]="itemInEdit"
			[editorMode]="editorMode"
			(memberCommitEvent)="completeEdit($event) ? (itemInEdit = null) : undefined"
			[isOwner]="isOwner(itemInEdit)"
			[rolesApi]="rolesApi"
			[palette]="getItemPaletteColors() | async"
			[itemList$]="itemList$"
			[usedColors]="getUsedColors() | async"
		>
		</add-edit-member>
	</app-item-list>
</div>
